import React from "react";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/modalSlice";
import Button from "../atoms/Button";

const SignUpButton = () => {
  const dispatch = useDispatch();
  return (
    <Button
      size="md"
      label="Sign up free"
      onClick={(e) => {
        e.preventDefault();
        dispatch(openModal("SignUp"));
      }}
    />
  );
};
export default SignUpButton;
